
export default {
  props: {
    specifications: {
      type: [Array, Object],
      required: true,
    },

    applicationTypes: {
      type: Array,
      required: true,
    },

    applicationScopes: {
      type: Array,
      required: true,
    },
  },

  computed: {
    notEmpty() {
      return !(
        this.specifications.length === 0 &&
        this.applicationTypes.length === 0 &&
        this.applicationScopes.length === 0
      )
    },
  },
}
